import axios from 'axios'
import { useEffect, useState } from 'react'
import { Get_Platforms } from '../api/api'

const usePlatformList = () => {
  const [platforms, setPlatforms] = useState(null)

  useEffect(() => {
    const getPlatforms = async () => {
      try {
        const res = await axios.get(Get_Platforms())
        setPlatforms(res.data)
      } catch (error) {
        setPlatforms(false)
      }
    }
    getPlatforms()
  }, [])

  return platforms
}

export default usePlatformList
